import { Box, Typography } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import CreateExternalUserInlineForm, { ICreateExternalUserInlineFormProps } from "./CreateExternalUserInlineForm";
import { useCreateExternalUserInlineSection } from "./CreateExternalUserInlineSection.hooks";
import { useCreateExternalUserInlineSectionStyles } from "./CreateExternalUserInlineSection.styles";

export interface ICreateExternalUserInlineSectionProps extends ICreateExternalUserInlineFormProps {}

function CreateExternalUserInlineSection(props: ICreateExternalUserInlineSectionProps) {
    const { translateString } = useTranslation();
    const styles = useCreateExternalUserInlineSectionStyles();
    const { isFormVisible, toggleForm, onCreated } = useCreateExternalUserInlineSection(props);

    return (
        <Box sx={styles.container}>
            <Typography sx={styles.toggleLink} onClick={toggleForm}>
                {translateString("addRecipient")}
            </Typography>

            {isFormVisible && <CreateExternalUserInlineForm existingEmails={props.existingEmails} onCreated={onCreated} />}
        </Box>
    );
}

export default CreateExternalUserInlineSection;
